import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  isAuthenticated: false,
  token: null,
  refreshToken: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action) => {
      const userData = action.payload.user;

      state.user = userData;
      state.isAuthenticated = true;
      state.token = userData?.token || null;
      state.refreshToken = userData?.refreshToken || null;

      // Store tokens in localStorage
      if (userData?.token) {
        const tokenKey = process.env.REACT_APP_AUTH_TOKEN_KEY || "auth_token";
        localStorage.setItem(tokenKey, userData.token);
        localStorage.setItem("authenticated", JSON.stringify(true));
        localStorage.setItem("login", JSON.stringify(true));
      }

      // Store refresh token
      if (userData?.refreshToken) {
        const refreshTokenKey = process.env.REACT_APP_REFRESH_TOKEN_KEY || "refresh_token";
        localStorage.setItem(refreshTokenKey, userData.refreshToken);
      }

      // Store user profile information
      if (userData) {
        localStorage.setItem("Name", userData.name || userData.username || "User");
        localStorage.setItem("user_id", userData.id?.toString() || "");
        localStorage.setItem("user_email", userData.email || "");
        localStorage.setItem("user_type", userData.userType || "");
        localStorage.setItem("partner_uuid", userData.partnerUuid || "");
        localStorage.setItem("country_id", userData.countryId?.toString() || "");
        localStorage.setItem("can_access_admin", userData.canAccessAdminPanel?.toString() || "false");

        if (userData.profilePicture) {
          localStorage.setItem("profileURL", userData.profilePicture);
        }

        // Store complete user object as JSON for easy access
        const userDataToStore = {
          id: userData.id,
          username: userData.username,
          email: userData.email,
          partnerUuid: userData.partnerUuid,
          countryId: userData.countryId,
          userType: userData.userType,
          active: userData.active,
          verified: userData.verified,
          canAccessAdminPanel: userData.canAccessAdminPanel,
          gender: userData.gender,
          birthDate: userData.birthDate,
        };
        localStorage.setItem("user_data", JSON.stringify(userDataToStore));
      }
    },
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.token = null;
      state.refreshToken = null;

      // Clear localStorage
      const tokenKey = process.env.REACT_APP_AUTH_TOKEN_KEY || "auth_token";
      const refreshTokenKey = process.env.REACT_APP_REFRESH_TOKEN_KEY || "refresh_token";
      localStorage.removeItem(tokenKey);
      localStorage.removeItem(refreshTokenKey);
      localStorage.removeItem("authenticated");
      localStorage.removeItem("login");
      localStorage.removeItem("Name");
      localStorage.removeItem("profileURL");
      localStorage.removeItem("user_id");
      localStorage.removeItem("user_email");
      localStorage.removeItem("user_type");
      localStorage.removeItem("partner_uuid");
      localStorage.removeItem("country_id");
      localStorage.removeItem("can_access_admin");
      localStorage.removeItem("user_data");
    },
    updateUser: (state, action) => {
      state.user = { ...state.user, ...action.payload };
    },
    refreshTokens: (state, action) => {
      const { token, refreshToken } = action.payload;
      state.token = token;
      state.refreshToken = refreshToken;
      localStorage.setItem(process.env.REACT_APP_AUTH_TOKEN_KEY || "auth_token", token);
      if (refreshToken) {
        localStorage.setItem(process.env.REACT_APP_REFRESH_TOKEN_KEY || "refresh_token", refreshToken);
      }
    },
  },
});

export const { login, logout, updateUser, refreshTokens } = authSlice.actions;
export default authSlice;
